// ----------------------------------------------------------------------

export function getClaimFlowAccess({ patientId, patient, aiResults }) {
  const hasPatient = Boolean(patientId && patient);
  const hasDocuments = hasPatient && Array.isArray(patient?.documents) && patient.documents.length > 0;
  const overallAiStatus = aiResults?.overall_status || 'PENDING';
  const aiProcessingTerminal = overallAiStatus === 'COMPLETED' || overallAiStatus === 'FAILED';
  const hasPolicyCoverageStep = hasPatient && hasDocuments && aiProcessingTerminal;
  const isApproved = hasPatient && patient?.approvalStatus === 'approved';

  return {
    hasPatient,
    hasDocuments,
    hasPolicyCoverageStep,
    isApproved,
    canAccess: {
      documentCollection: hasPatient,
      aiProcessing: hasDocuments,
      policyCoverage: hasPolicyCoverageStep,
      aiVerification: hasPolicyCoverageStep,
      approvalWorkflow: hasPolicyCoverageStep,
      finance: isApproved,
      claimClosure: isApproved,
    },
  };
}

